/**
 * API endpoint path constants for the testing service.
 * No logic, no imports — raw strings only.
 */

export const PLANS_ENDPOINT = "/api/plans";
export const planEndpoint = (id: string) => `/api/plans/${id}`;
export const planExecuteEndpoint = (id: string) => `/api/plans/${id}/execute`;
export const planVerifyEndpoint = (id: string) => `/api/plans/${id}/verify`;
export const planOpenUrlEndpoint = (id: string) => `/api/plans/${id}/open-url`;
export const planRepairAnswerEndpoint = (id: string) => `/api/plans/${id}/repair/answer`;
export const planHealProposalAcceptEndpoint = (id: string) =>
  `/api/plans/${id}/heal-proposal/accept`;
export const planHealProposalRejectEndpoint = (id: string) =>
  `/api/plans/${id}/heal-proposal/reject`;
// Org-config consent loop: apply a proven ORG_CONFIG fix to the org, then re-run to verify the diagnosis.
export const planOrgConfigAcceptEndpoint = (planId: string, changeId: string) =>
  `/api/plans/${planId}/org-config/${changeId}/accept`;
export const planOrgConfigRejectEndpoint = (planId: string, changeId: string) =>
  `/api/plans/${planId}/org-config/${changeId}/reject`;
export const planOrgConfigRevertEndpoint = (planId: string, changeId: string) =>
  `/api/plans/${planId}/org-config/${changeId}/revert`;
export const planOrgConfigVerdictEndpoint = (planId: string, changeId: string) =>
  `/api/plans/${planId}/org-config/${changeId}/verdict`;
export const RUNS_ENDPOINT = "/api/runs";
export const runEndpoint = (id: string) => `/api/runs/${id}`;
export const runAbortEndpoint = (id: string) => `/api/runs/${id}/abort`;
export const runHealEndpoint = (id: string) => `/api/runs/${id}/heal`;
/** Mints a short-lived, browser-openable URL for a run's HTML report (no bearer needed). */
export const runReportAccessEndpoint = (id: string) => `/api/runs/${id}/report-access`;
export const CHAT_ENDPOINT = "/api/chat/messages";
export const RECENT_CHANGES_ENDPOINT = "/api/changes/recent";
